export default "__VITE_ASSET__CbbrvhsB__"